import React from 'react';
import { FcGoogle } from 'react-icons/fc';
import Button from './Button';
import { initiateGoogleOAuth } from '../../utils/googleOAuth';

const GoogleButton = ({ text = "Continue with Google", loading = false }) => {
    const handleGoogleLogin = () => {
        try {
            initiateGoogleOAuth();
        } catch (error) {
            console.error('Error initiating Google OAuth:', error);
        }
    };

    return (
        <Button
            type="button"
            variant="outline"
            size="lg"
            onClick={handleGoogleLogin}
            loading={loading}
            icon={FcGoogle}
            className="w-full bg-white border-2 border-gray-300 hover:bg-gray-50 hover:border-gray-400 shadow-sm hover:shadow-md text-gray-900 font-semibold dark:bg-boxdark dark:border-strokedark dark:text-white dark:hover:bg-boxdark-2"
        >
            {text}
        </Button>
    );
};

export default GoogleButton;
